import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { FaTrophy, FaFutbol, FaDice, FaExclamationTriangle } from "react-icons/fa";
import { GiSparkles } from "react-icons/gi";
import BottomNavigation from "../BottomNavigation";
import Footer from "../Home/Footer";

const LimitCard = ({ icon, title, text, limitLabel }) => (
  <div className="rounded-2xl overflow-hidden bg-secondary-700/70 shadow-2xl backdrop-blur-sm">
    <div className="px-5 py-5 flex items-start gap-4">
      <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary-400/15 border border-primary-400/40 text-primary-400 text-xl flex items-center justify-center">
        {icon}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-white font-bold text-base break-words">{title}</div>
        <p className="text-white/70 text-sm leading-relaxed mt-1">{text}</p>

        <div className="mt-4 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-secondary-50/20 to-primary-400/10 border border-primary-400/30 px-4 py-2">
          <span className="text-white/60 text-xs">{limitLabel}</span>
          <span className="text-primary-400 font-extrabold text-lg leading-none">€25,000</span>
        </div>
      </div>
    </div>
  </div>
);

const MaxWinLimits = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        style={{
          overflow: "auto",
          height: "calc(100dvh - 80px)",
          WebkitOverflowScrolling: "touch",
          backgroundImage: `url(${require("../../../assets/img/bg.jpg")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          paddingBottom: "calc(120px + env(safe-area-inset-bottom))",
        }}
        className="bg-secondary-500"
      >
        <Helmet>
          <title>{t("TITLE_MAX_WIN_LIMITS")}</title>
        </Helmet>

        <div className="px-4 pt-6 max-w-2xl mx-auto space-y-4">
          {/* Hero */}
          <div className="rounded-2xl overflow-hidden bg-secondary-700/70 shadow-2xl backdrop-blur-lg">
            <div className="relative bg-gradient-to-br from-secondary-50/40 via-primary-400/40 to-secondary-50/40 px-5 py-6 overflow-hidden">
              <div
                className="absolute inset-0 opacity-30"
                style={{
                  background:
                    "conic-gradient(from 210deg at 25% 30%, transparent, rgba(255,255,255,0.35), transparent 35%)",
                }}
              />
              <div className="absolute -end-8 -top-8 w-40 h-40 rounded-full bg-primary-400/25 blur-3xl" />
              <div className="absolute -start-10 bottom-0 w-32 h-32 rounded-full bg-primary-400/25 blur-3xl" />

              <div className="relative flex items-center gap-3">
                <div className="relative flex-shrink-0">
                  <GiSparkles className="absolute -top-2 -start-2 text-primary-300 text-lg" />
                  <div className="w-14 h-14 rounded-full border-4 border-primary-400 bg-secondary-900/70 shadow-lg flex items-center justify-center">
                    <FaTrophy className="text-primary-400 text-xl" />
                  </div>
                </div>
                <div className="min-w-0">
                  <div className="text-white font-extrabold text-xl break-words">
                    {t("MAX_WIN_HERO_TITLE")}
                  </div>
                  <div className="text-white/60 text-xs mt-0.5 break-words">
                    {t("MAX_WIN_HERO_SUBTITLE")}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sports limit */}
          <LimitCard
            icon={<FaFutbol />}
            title={t("MAX_WIN_SPORTS_TITLE")}
            text={t("MAX_WIN_SPORTS_TEXT")}
            limitLabel={t("MAX_WIN_LIMIT_LABEL")}
          />

          {/* Casino limit */}
          <LimitCard
            icon={<FaDice />}
            title={t("MAX_WIN_CASINO_TITLE")}
            text={t("MAX_WIN_CASINO_TEXT")}
            limitLabel={t("MAX_WIN_LIMIT_LABEL")}
          />

          {/* Warning */}
          <div className="rounded-2xl overflow-hidden bg-red-500/10 border border-red-400/30 shadow-2xl backdrop-blur-sm">
            <div className="px-5 py-4 flex items-start gap-3">
              <div className="flex-shrink-0 w-9 h-9 mt-0.5 rounded-full bg-red-400/15 border border-red-400/40 text-red-400 flex items-center justify-center">
                <FaExclamationTriangle className="text-sm" />
              </div>
              <div className="min-w-0">
                <div className="text-white font-bold text-sm break-words">
                  {t("MAX_WIN_WARNING_TITLE")}
                </div>
                <p className="text-white/70 text-sm leading-relaxed mt-1">
                  {t("MAX_WIN_WARNING_TEXT")}
                </p>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>

      <BottomNavigation isNavVisible={true} />
    </>
  );
};

export default MaxWinLimits;
